export const generateGuid = () => {
  const pattern = "xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx";
  return pattern.replace(/[xy]/g, (char) => {
    const randomHex = (Math.random() * 16) | 0;
    const value = char === "x" ? randomHex : (randomHex & 0x3) | 0x8;
    return value.toString(16);
  });
};
